module.exports = __webpack_public_path__ + "img/logobio.fb9f783a.png";